var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style['pt-header']},[_c('div',{staticClass:"header-message"},[_c('img',{attrs:{"src":require('images/org-logo.png')}}),_c('div',[_vm._v(_vm._s(_vm.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }